// core
import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';

// constants
import {AppConstants} from '../../utils/constants';

// models
import {EmailConfirmationKind, EmailConfirmationOutcome} from '../model/email-confirmation.model';

/**
 * Redeems the token from a confirmation mail.
 *
 * Uses HttpClient directly instead of CustomHttp: CustomHttp shows a "success" toast for every successful request,
 * which would contradict a page that reports an expired link, and it drops the HTTP status of a failure.
 */
@Injectable()
export class EmailConfirmationService {

  constructor(private http: HttpClient) {
  }

  public confirm(kind: EmailConfirmationKind, token: string): Observable<EmailConfirmationOutcome> {
    const endpoint = kind === 'registration'
      ? AppConstants.confirmRegistrationEndpoint
      : AppConstants.verifyEmailEndpoint;

    return this.http
      .post<{ result: EmailConfirmationOutcome }>(endpoint, {token})
      .pipe(map(response => response.result));
  }
}
